import { render, staticRenderFns } from "./AromaReportProfile.vue?vue&type=template&id=187a94c7&scoped=true"
import script from "./AromaReportProfile.vue?vue&type=script&lang=js"
export * from "./AromaReportProfile.vue?vue&type=script&lang=js"
import style0 from "./AromaReportProfile.vue?vue&type=style&index=0&id=187a94c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a94c7",
  null
  
)

export default component.exports